<!-- VPN Status Indicator för admin -->
<div class="vpn-status-indicator" *ngIf="loggedIn && (user?.role === 'admin' || user?.role === 'developer') && vpnConnectedCount > 0">
  <span class="vpn-status-text">
    <i class="fas fa-network-wired me-1"></i>
    {{ vpnConnectedCount }} {{ vpnConnectedCount === 1 ? 'användare ansluten' : 'användare anslutna' }} till VPN
  </span>
</div>
<nav class="navbar navbar-expand-lg navbar-dark bg-dark custom-navbar">
  <div class="container-fluid">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainNavCollapse" aria-controls="mainNavCollapse" aria-expanded="false" aria-label="Visa meny">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="mainNavCollapse">
    <ul class="navbar-nav ms-auto align-items-center custom-menu">
      <li class="nav-item">
        <a class="nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Hem</a>
      </li>

      <!-- ============ REBOTLING — kärna ============ -->
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" id="rebotlingDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          <span class="line-dot" [class.line-dot-on]="rebotlingRunning" [class.line-dot-off]="!rebotlingRunning"></span>
          Rebotling
          <span class="badge bg-danger ms-1" *ngIf="loggedIn && urgentNoteCount > 0">{{ urgentNoteCount }}</span>
        </a>
        <ul class="dropdown-menu dropdown-menu-dark" aria-labelledby="rebotlingDropdown">
          <li *ngIf="ff.canAccess('rebotling/live')"><a class="dropdown-item" routerLink="/rebotling/live">Live</a></li>
          <li *ngIf="ff.canAccess('rebotling/skiftrapport')"><a class="dropdown-item" routerLink="/rebotling/skiftrapport">Skiftrapport</a></li>
          <li *ngIf="ff.canAccess('rebotling/statistik')"><a class="dropdown-item" routerLink="/rebotling/statistik">Statistik</a></li>
          <li *ngIf="loggedIn"><a class="dropdown-item" routerLink="/bemanning-optimerare"><i class="fas fa-users-cog me-2"></i>Bemanning</a></li>
          <li *ngIf="loggedIn && (user?.role === 'admin' || user?.role === 'developer')"><hr class="dropdown-divider"></li>
          <li *ngIf="ff.canAccess('rebotling/admin')"><a class="dropdown-item text-warning" routerLink="/rebotling/admin"><i class="fas fa-cogs me-2"></i>Admin</a></li>
          <li *ngIf="ff.canAccess('rebotling/bonus')"><a class="dropdown-item text-warning" routerLink="/rebotling/bonus"><i class="fas fa-trophy me-2"></i>Bonus</a></li>
          <li *ngIf="ff.canAccess('rebotling/bonus-admin')"><a class="dropdown-item text-warning" routerLink="/rebotling/bonus-admin"><i class="fas fa-sliders-h me-2"></i>Bonus Admin</a></li>
          <li *ngIf="ff.canAccess('rebotling/admin')"><a class="dropdown-item text-warning" routerLink="/rebotling/plc-diagnostik"><i class="fas fa-terminal me-2"></i>PLC Diagnostik</a></li>
          <li *ngIf="user?.role === 'admin' || user?.role === 'developer'"><a class="dropdown-item text-warning" routerLink="/rebotling/operator-prestation"><i class="fas fa-chart-line me-2"></i>Operatörer</a></li>
          <li *ngIf="ff.canAccess('rebotling/overlamning')">
            <a class="dropdown-item" routerLink="/rebotling/overlamning">
              <i class="fas fa-exchange-alt me-2 text-muted"></i>Skiftöverlämning
              <span class="badge bg-danger ms-2" *ngIf="urgentNoteCount > 0">{{ urgentNoteCount }}</span>
            </a>
          </li>
          <li><hr class="dropdown-divider"></li>
          <li *ngIf="loggedIn">
            <a class="dropdown-item text-info" routerLink="/funktioner">
              <i class="fas fa-th-large me-2"></i>Visa alla &rarr;
            </a>
          </li>
        </ul>
      </li>

      <!-- ============ ÖVRIGA LINJER ============ -->
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" id="tvattlinjeDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          <span class="line-dot" [class.line-dot-on]="tvattlinjeRunning" [class.line-dot-off]="!tvattlinjeRunning"></span>
          Tvätt
        </a>
        <ul class="dropdown-menu dropdown-menu-dark" aria-labelledby="tvattlinjeDropdown">
          <li *ngIf="ff.canAccess('tvattlinje/live')"><a class="dropdown-item" routerLink="/tvattlinje/live">Live</a></li>
          <li *ngIf="ff.canAccess('tvattlinje/skiftrapport')"><a class="dropdown-item" routerLink="/tvattlinje/skiftrapport">Skiftrapport</a></li>
          <li *ngIf="ff.canAccess('tvattlinje/statistik')"><a class="dropdown-item" routerLink="/tvattlinje/statistik">Statistik</a></li>
          <li *ngIf="ff.canAccess('bemanning-optimerare')"><a class="dropdown-item" routerLink="/bemanning-optimerare"><i class="fas fa-users-cog me-2"></i>Bemanning</a></li>
          <li *ngIf="loggedIn && (user?.role === 'admin' || user?.role === 'developer')"><hr class="dropdown-divider"></li>
          <li *ngIf="ff.canAccess('tvattlinje/admin')"><a class="dropdown-item text-warning" routerLink="/tvattlinje/admin"><i class="fas fa-cogs me-2"></i>Admin</a></li>
          <li *ngIf="ff.canAccess('tvattlinje/admin')"><a class="dropdown-item text-warning" routerLink="/tvattlinje/plc-diagnostik"><i class="fas fa-terminal me-2"></i>PLC Diagnostik</a></li>
          <li *ngIf="user?.role === 'admin' || user?.role === 'developer'"><a class="dropdown-item text-warning" routerLink="/tvattlinje/operator-prestation"><i class="fas fa-chart-line me-2"></i>Operatörer</a></li>
        </ul>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" id="saglinjeDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          Såg
        </a>
        <ul class="dropdown-menu dropdown-menu-dark" aria-labelledby="saglinjeDropdown">
          <li *ngIf="ff.canAccess('saglinje/live')"><a class="dropdown-item" routerLink="/saglinje/live">Live</a></li>
          <li *ngIf="ff.canAccess('saglinje/skiftrapport')"><a class="dropdown-item" routerLink="/saglinje/skiftrapport">Skiftrapport</a></li>
          <li *ngIf="ff.canAccess('saglinje/statistik')"><a class="dropdown-item" routerLink="/saglinje/statistik">Statistik</a></li>
          <li *ngIf="loggedIn && (user?.role === 'admin' || user?.role === 'developer')"><hr class="dropdown-divider"></li>
          <li *ngIf="ff.canAccess('saglinje/admin')"><a class="dropdown-item text-warning" routerLink="/saglinje/admin"><i class="fas fa-cogs me-2"></i>Admin</a></li>
        </ul>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" id="klassificeringslinjeDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          Klassificering
        </a>
        <ul class="dropdown-menu dropdown-menu-dark" aria-labelledby="klassificeringslinjeDropdown">
          <li *ngIf="ff.canAccess('klassificeringslinje/live')"><a class="dropdown-item" routerLink="/klassificeringslinje/live">Live</a></li>
          <li *ngIf="ff.canAccess('klassificeringslinje/skiftrapport')"><a class="dropdown-item" routerLink="/klassificeringslinje/skiftrapport">Skiftrapport</a></li>
          <li *ngIf="ff.canAccess('klassificeringslinje/statistik')"><a class="dropdown-item" routerLink="/klassificeringslinje/statistik">Statistik</a></li>
          <li *ngIf="loggedIn && (user?.role === 'admin' || user?.role === 'developer')"><hr class="dropdown-divider"></li>
          <li *ngIf="ff.canAccess('klassificeringslinje/admin')"><a class="dropdown-item text-warning" routerLink="/klassificeringslinje/admin"><i class="fas fa-cogs me-2"></i>Admin</a></li>
        </ul>
      </li>

      <li class="nav-item" *ngIf="ff.canAccess('favoriter')">
        <a class="nav-link" routerLink="/favoriter" title="Mina favoriter">
          <i class="fas fa-star me-1" style="color:#ecc94b"></i>Favoriter
        </a>
      </li>

      <!-- Notifikationscentral -->
      <li class="nav-item dropdown" *ngIf="loggedIn">
        <a class="nav-link position-relative" href="#" id="notifDropdown" role="button"
           data-bs-toggle="dropdown" aria-expanded="false" title="Notifikationer">
          <i class="fas fa-bell"></i>
          <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger notif-badge"
                *ngIf="(urgentNoteCount + certExpiryCount + activeAlertsCount) > 0">
            {{ urgentNoteCount + certExpiryCount + activeAlertsCount }}
          </span>
        </a>
        <ul class="dropdown-menu dropdown-menu-dark dropdown-menu-end notif-dropdown" aria-labelledby="notifDropdown" style="min-width:300px">
          <li class="dropdown-header">
            <i class="fas fa-bell me-1"></i>Notifikationer
          </li>
          <li *ngIf="urgentNoteCount === 0 && certExpiryCount === 0 && activeAlertsCount === 0">
            <span class="dropdown-item-text text-muted small px-3 py-2 d-block">Inga nya notifikationer</span>
          </li>
          <li *ngIf="urgentNoteCount > 0">
            <a class="dropdown-item" routerLink="/rebotling/overlamning">
              <i class="fas fa-exclamation-triangle text-danger me-2"></i>
              {{ urgentNoteCount }} brådskande {{ urgentNoteCount === 1 ? 'notering' : 'noteringar' }}
            </a>
          </li>
          <li *ngIf="certExpiryCount > 0">
            <a class="dropdown-item" routerLink="/admin/certifiering">
              <i class="fas fa-certificate text-warning me-2"></i>
              {{ certExpiryCount }} certifieringar snart utgångna
            </a>
          </li>
          <li *ngIf="activeAlertsCount > 0 && (user?.role === 'admin' || user?.role === 'developer')">
            <a class="dropdown-item" routerLink="/rebotling/alerts">
              <i class="fas fa-bell text-danger me-2"></i>
              {{ activeAlertsCount }} aktiv{{ activeAlertsCount !== 1 ? 'a' : '' }} varning{{ activeAlertsCount !== 1 ? 'ar' : '' }}
            </a>
          </li>
        </ul>
      </li>

      <li class="nav-item dropdown" *ngIf="!loggedIn">
        <a class="nav-link dropdown-toggle" href="#" id="loginDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          Logga in
        </a>
        <ul class="dropdown-menu dropdown-menu-dark" aria-labelledby="loginDropdown">
          <li><a class="dropdown-item" routerLink="/login">Logga in</a></li>
          <li><a class="dropdown-item" routerLink="/register">Registrera</a></li>
        </ul>
      </li>

      <!-- ============ KONTO-MENY (inkl Rapporter, Information, Admin) ============ -->
      <li class="nav-item dropdown" *ngIf="loggedIn">
        <a class="nav-link dropdown-toggle user-name" href="#" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          {{ user?.username }}
        </a>
        <ul class="dropdown-menu dropdown-menu-dark" aria-labelledby="userDropdown">
          <li>
            <a class="dropdown-item d-flex justify-content-between align-items-center"
               href="#accountCollapse" data-bs-toggle="collapse" role="button"
               aria-expanded="false" aria-controls="accountCollapse"
               (click)="$event.stopPropagation()">
              <span><i class="fas fa-user-circle me-2"></i>Mitt konto</span>
              <i class="fas fa-chevron-down small"></i>
            </a>
          </li>
          <li id="accountCollapse" class="collapse px-3 py-2 account-settings">
            <form (ngSubmit)="updateProfile()" (click)="$event.stopPropagation()" novalidate>
              <div class="mb-2">
                <label class="form-label account-label" for="accountEmail">E-post</label>
                <input
                  type="email"
                  class="form-control form-control-sm"
                  id="accountEmail"
                  name="accountEmail"
                  required
                  maxlength="255"
                  [(ngModel)]="profileForm.email" />
              </div>
              <div class="mb-2">
                <label class="form-label account-label" for="accountOperatorId">
                  Operatör-ID
                  <small class="text-muted ms-1">(för Min Bonus)</small>
                </label>
                <input
                  type="number"
                  class="form-control form-control-sm"
                  id="accountOperatorId"
                  name="accountOperatorId"
                  placeholder="T.ex. 12345"
                  min="1"
                  [(ngModel)]="profileForm.operatorId"  max="99999" />
              </div>
              <div class="mb-2">
                <label class="form-label account-label" for="newPassword">Nytt lösenord</label>
                <input
                  type="password"
                  class="form-control form-control-sm"
                  id="newPassword"
                  name="newPassword"
                  minlength="8"
                  maxlength="128"
                  [(ngModel)]="profileForm.newPassword" />
              </div>
              <div class="mb-2">
                <label class="form-label account-label" for="confirmPassword">Bekräfta nytt lösenord</label>
                <input
                  type="password"
                  class="form-control form-control-sm"
                  id="confirmPassword"
                  name="confirmPassword"
                  minlength="8"
                  maxlength="128"
                  [(ngModel)]="profileForm.confirmPassword" />
              </div>
              <div class="mb-2">
                <label class="form-label account-label" for="currentPassword">Nuvarande lösenord</label>
                <input
                  type="password"
                  class="form-control form-control-sm"
                  id="currentPassword"
                  name="currentPassword"
                  maxlength="128"
                  [required]="(profileForm.newPassword.length || 0) > 0 || (profileForm.confirmPassword.length || 0) > 0"
                  [(ngModel)]="profileForm.currentPassword" />
                <small class="text-muted d-block mt-1">Behövs bara vid byte av lösenord.</small>
              </div>
              <div class="alert alert-success py-1 px-2 mb-2" *ngIf="profileMessage">{{ profileMessage }}</div>
              <div class="alert alert-danger py-1 px-2 mb-2" *ngIf="profileError">{{ profileError }}</div>
              <button class="btn btn-sm btn-primary w-100" type="submit" [disabled]="savingProfile || !profileForm.email.trim()">
                {{ savingProfile ? 'Sparar...' : 'Spara' }}
              </button>
            </form>
          </li>
          <li><hr class="dropdown-divider" /></li>

          <!-- Rapporter -->
          <li class="dropdown-header">Rapporter</li>
          <li *ngIf="ff.canAccess('statistik/overblick')"><a class="dropdown-item" routerLink="/statistik/overblick"><i class="fas fa-chart-line me-2" style="color:#4fd1c5"></i>Statistik-överblick</a></li>
          <li *ngIf="ff.canAccess('rapporter/manad')"><a class="dropdown-item" routerLink="/rapporter/manad"><i class="fas fa-calendar-alt me-2"></i>Månadsrapport</a></li>
          <li *ngIf="ff.canAccess('rapporter/vecka')"><a class="dropdown-item" routerLink="/rapporter/vecka"><i class="fas fa-calendar-week me-2"></i>Veckorapport</a></li>
          <li><hr class="dropdown-divider" /></li>

          <!-- Information -->
          <li class="dropdown-header">Information</li>
          <li><a class="dropdown-item" routerLink="/about"><i class="fas fa-info-circle me-2"></i>Om systemet</a></li>
          <li><a class="dropdown-item" routerLink="/contact"><i class="fas fa-envelope me-2"></i>Kontakt</a></li>

          <!-- Admin (bara admin/developer) -->
          <ng-container *ngIf="user?.role === 'admin' || user?.role === 'developer'">
            <li><hr class="dropdown-divider" /></li>
            <li>
              <a class="dropdown-item d-flex justify-content-between align-items-center"
                 href="#adminCollapse" data-bs-toggle="collapse" role="button"
                 aria-expanded="false" aria-controls="adminCollapse"
                 (click)="$event.stopPropagation()">
                <span><i class="fas fa-cogs me-2"></i>Admin</span>
                <i class="fas fa-chevron-down small"></i>
              </a>
            </li>
            <li>
              <ul class="list-unstyled collapse mb-0" id="adminCollapse">
                <li class="dropdown-header" style="color:#718096;font-size:0.7rem;text-transform:uppercase;letter-spacing:0.05em;">Översikt</li>
                <li *ngIf="ff.canAccess('oversikt')"><a class="dropdown-item text-info" routerLink="/oversikt"><i class="fas fa-tachometer-alt me-2"></i>Översikt</a></li>
                <li *ngIf="ff.canAccess('rebotling/alerts')">
                  <a class="dropdown-item" routerLink="/rebotling/alerts">
                    <i class="fas fa-bell me-2 text-warning"></i>Varningar
                    <span class="badge bg-danger ms-1" *ngIf="activeAlertsCount > 0">{{ activeAlertsCount }}</span>
                  </a>
                </li>
                <li *ngIf="ff.canAccess('stopporsaker')"><a class="dropdown-item" routerLink="/stopporsaker"><i class="fas fa-exclamation-triangle me-2"></i>Stopporsaker</a></li>
                <li><hr class="dropdown-divider"></li>
                <li class="dropdown-header" style="color:#718096;font-size:0.7rem;text-transform:uppercase;letter-spacing:0.05em;">Användare &amp; behörighet</li>
                <li *ngIf="ff.canAccess('admin/users')"><a class="dropdown-item" routerLink="/admin/users">Användare</a></li>
                <li *ngIf="ff.canAccess('admin/create-user')"><a class="dropdown-item" routerLink="/admin/create-user">Skapa användare</a></li>
                <li *ngIf="ff.canAccess('admin/operators')"><a class="dropdown-item" routerLink="/admin/operators"><i class="fas fa-id-badge me-2"></i>Operatörer</a></li>
                <li *ngIf="ff.canAccess('admin/skiftplan')"><a class="dropdown-item" routerLink="/admin/skiftplan"><i class="fas fa-calendar-week me-2"></i>Skiftplan</a></li>
                <li *ngIf="ff.canAccess('admin/certifiering')">
                  <a class="dropdown-item" routerLink="/admin/certifiering">
                    <i class="fas fa-certificate me-2"></i>Certifiering
                    <span class="badge bg-warning text-dark ms-1" *ngIf="certExpiryCount > 0">{{ certExpiryCount }}</span>
                  </a>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li class="dropdown-header" style="color:#718096;font-size:0.7rem;text-transform:uppercase;letter-spacing:0.05em;">Operatörsanalys</li>
                <li><a class="dropdown-item" routerLink="/admin/operatorsanalys"><i class="fas fa-users-cog me-2"></i>Operatörsanalys</a></li>
                <li><hr class="dropdown-divider"></li>
                <li class="dropdown-header" style="color:#718096;font-size:0.7rem;text-transform:uppercase;letter-spacing:0.05em;">System</li>
                <li *ngIf="ff.canAccess('admin/underhall')"><a class="dropdown-item" routerLink="/admin/underhall"><i class="fas fa-tools me-2"></i>Underhållslogg</a></li>
                <li *ngIf="ff.canAccess('admin/vpn')"><a class="dropdown-item" routerLink="/admin/vpn"><i class="fas fa-network-wired me-2"></i>VPN</a></li>
                <li *ngIf="ff.canAccess('admin/audit')"><a class="dropdown-item" routerLink="/admin/audit"><i class="fas fa-history me-2"></i>Aktivitetslogg</a></li>
                <li *ngIf="ff.canAccess('admin/news')"><a class="dropdown-item" routerLink="/admin/news"><i class="fas fa-newspaper me-2"></i>Nyheter</a></li>
                <li><hr class="dropdown-divider"></li>
                <li class="dropdown-header" style="color:#718096;font-size:0.7rem;text-transform:uppercase;letter-spacing:0.05em;">Operator-verktyg</li>
                <li *ngIf="ff.canAccess('bemanning-optimerare')"><a class="dropdown-item" routerLink="/bemanning-optimerare"><i class="fas fa-users-cog me-2" style="color:#ed8936"></i>Bemanning-optimerare</a></li>
                <li><hr class="dropdown-divider"></li>
                <li class="dropdown-header" style="color:#718096;font-size:0.7rem;text-transform:uppercase;letter-spacing:0.05em;">Utveckling</li>
                <li *ngIf="ff.canAccess('admin/feature-flags')"><a class="dropdown-item text-info" routerLink="/admin/feature-flags"><i class="fas fa-toggle-on me-2"></i>Feature Flags</a></li>
              </ul>
            </li>
          </ng-container>

          <li><hr class="dropdown-divider" /></li>
          <li><button class="dropdown-item" type="button" (click)="logout()">Logga ut</button></li>
        </ul>
      </li>

      <li class="nav-item dropdown menu-selector-item">
        <select aria-label="Välj meny" [(ngModel)]="selectedMenu" (change)="onMenuChange()" class="menu-selector">
          <option value="Älvängen">Älvängen</option>
          <option value="Moss">Moss</option>
        </select>
      </li>
    </ul>
    </div>
  </div>
</nav>
